import { createFileRoute } from '@tanstack/react-router';
import { AuthLayout } from '@/features/auth/components/auth-layout/AuthLayout';
import { ForgotPasswordPage } from '@/features/auth/pages/forgot-password-page/ForgotPasswordPage';

const RouteComponent = () => (
  <AuthLayout>
    <ForgotPasswordPage />
  </AuthLayout>
);

export const Route = createFileRoute('/forgot-password')({
  component: RouteComponent,
});
